"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValidateAlertContactStatus = exports.getRequestsEligibilityState = exports.getMultiRecipientUpdateStatus = exports.getMultiRecipientsState = exports.getRequestsState = exports.getAppointmentToBook = exports.getInterventionFormData = exports.getAppointementBookingStatus = exports.getWorkExectionId = exports.getAvailableSlots = exports.getSelectedAppointment = exports.getSubscriptionForm = exports.getInterventionTypes = void 0;
var i18n_1 = __importStar(require("../i18n"));
var settingsSelectors_1 = require("./settingsSelectors");
/**
 * récupere les valeurs de la liste déroulante pour le type de résidence
 * @param {*} states L'ensemble des states de ssm
 */
function getInterventionTypes(states) {
    var lang = (0, settingsSelectors_1.getLanguage)(states);
    var translation = (0, i18n_1.default)(lang ? lang : i18n_1.langTypes.FR);
    return [
        {
            id: 0,
            label: translation.exchanges.appointment.interventionType
                .MeterRenew,
            value: 'MeterRenew'
        }
    ];
}
exports.getInterventionTypes = getInterventionTypes;
/**
 * récupere le formulaire à envoyer vers le back
 * @param {*} store Store redux hébergeant le state
 */
function getSubscriptionForm(states) {
    return states.exchange.formData.informationData;
}
exports.getSubscriptionForm = getSubscriptionForm;
function getSelectedAppointment(states) {
    return states.exchange.formData.selectedAppointment;
}
exports.getSelectedAppointment = getSelectedAppointment;
function getAvailableSlots(states) {
    return states.exchange.appointments.appointmentsList;
}
exports.getAvailableSlots = getAvailableSlots;
/**
 * get work execution id from the slots
 * @param {*} store Store redux hébergeant le state
 */
function getWorkExectionId(states) {
    var _a;
    return (_a = states.exchange.appointments.appointmentsList) === null || _a === void 0 ? void 0 : _a.workexecutionId;
}
exports.getWorkExectionId = getWorkExectionId;
/**
 * get appointement booking status
 * @param {*} store Store redux hébergeant le state
 */
function getAppointementBookingStatus(states) {
    return states.exchange.bookingStatus;
}
exports.getAppointementBookingStatus = getAppointementBookingStatus;
/**
 * Récupère les informations de planification de l'information.
 * @param states L'ensemble des states de ssm
 * @returns
 */
function getInterventionFormData(states) {
    var _a, _b, _c;
    var lang = (0, settingsSelectors_1.getLanguage)(states);
    var translation = (0, i18n_1.default)(lang ? lang : i18n_1.langTypes.FR);
    var formData = states.exchange.formData;
    return {
        extraInformation: (_a = formData.informationData) === null || _a === void 0 ? void 0 : _a.extraInformation,
        contactInfo: (_b = formData.informationData) === null || _b === void 0 ? void 0 : _b.phone,
        appointmentReason: translation.exchanges.appointment.interventionType.MeterRenew,
        selectedAppointmentDisplayInfo: (_c = formData.selectedAppointment) === null || _c === void 0 ? void 0 : _c.getDisplayInfo(lang)
    };
}
exports.getInterventionFormData = getInterventionFormData;
/**
 * Construct the appointment to book object.
 * @param states L'ensemble des states de ssm
 * @param sectionSubscriptionId the section subscription ID
 * @returns
 */
function getAppointmentToBook(states, sectionSubscriptionId) {
    var _a, _b;
    var formData = states.exchange.formData;
    var selectedAppointment = getSelectedAppointment(states);
    if (selectedAppointment)
        return {
            startDate: selectedAppointment.startDate,
            endDate: selectedAppointment.endDate,
            sectionSubscriptionId: sectionSubscriptionId,
            phoneNumber: ((_a = formData.informationData) === null || _a === void 0 ? void 0 : _a.phone) || '',
            extraInformation: (_b = formData.informationData) === null || _b === void 0 ? void 0 : _b.extraInformation
        };
    else
        throw Error('Missing selected appointment');
}
exports.getAppointmentToBook = getAppointmentToBook;
function getRequestsState(states) {
    return states.exchange.clientRequests;
}
exports.getRequestsState = getRequestsState;
function getMultiRecipientsState(states) {
    return states.exchange.alertsMultiRecipients;
}
exports.getMultiRecipientsState = getMultiRecipientsState;
function getMultiRecipientUpdateStatus(states) {
    return states.exchange.updateRecipientStatus;
}
exports.getMultiRecipientUpdateStatus = getMultiRecipientUpdateStatus;
function getRequestsEligibilityState(states) {
    return states.exchange.clientRequestsEligibility.clientRequestsEligibility;
}
exports.getRequestsEligibilityState = getRequestsEligibilityState;
function getValidateAlertContactStatus(states) {
    return states.exchange.validateAlertContactStatus;
}
exports.getValidateAlertContactStatus = getValidateAlertContactStatus;
